import React from 'react';

import PlaceStudents from './place_students';

import '../../../css/hsms/place_students.css';

export default function PlaceStudentsScreen({ schoolSubscribed, subscreenRestricted, subscreenLocked, isLoading, setIsLoading, subscreen, schoolInfo, schoolType, scheduleInfo, userInfo, departmentsLoading, departments, appSubscreens, rolePages, subscreenSelect, getNewData, showNextButton, handleMoveToNextScreen, setLoadScreen }) {
	return (
		<div id='section-placement-main-container'>
			{isLoading ?
				(
					<div className='center-text'>
						<img src={require('../../../images/balls.gif')} alt='Loading...' style={{height:'40px'}}/>
					</div>
				) :
				(
					<>
					{(() => {
						switch(subscreen) {
							case 'place_students':
								return <PlaceStudents schoolSubscribed={schoolSubscribed} subscreenRestricted={subscreenRestricted} subscreenLocked={subscreenLocked} isLoading={isLoading} setIsLoading={setIsLoading} schoolInfo={schoolInfo} schoolType={schoolType} scheduleInfo={scheduleInfo} userInfo={userInfo} departmentsLoading={departmentsLoading} departments={departments} appSubscreens={appSubscreens} rolePages={rolePages} subscreenSelect={subscreenSelect} getNewData={getNewData} showNextButton={showNextButton} handleMoveToNextScreen={handleMoveToNextScreen} setLoadScreen={setLoadScreen}/>;
							case 'dashboard':
								return null;
							default:
								return null;
						}
					})()}
					</>
				)
			}
		</div>
	);
}
